import { FC, useEffect } from 'react'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { useCollapse } from '../../routes/collapse-context'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../components/custom_components/FlexRow'
import { PerEmpty } from '../../components/custom_components/Empty'
import { useCompanyManagerDashboardListOfCompanies } from '../../graphql/company-manager-dashboard/useCompanyManagerDashboardListOfCompanies'
import { useDashboardStore } from './DashboardStore'
import DashboardViewLayout from './components/DashboardViewLayout'
import { NewLoadingAndErrors } from '../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import BackgroundBox from '../../components/custom_components/BackgroundBox'
import { useAuth } from '../../context/auth-context'
import { RoleName } from '../../types'
import { getDashboardEmptyMessageKey } from './utils/dashboardEmptyViewUtil'

const DashboardView: FC = () => {
  const [t] = useTranslation()
  const { user } = useAuth()
  const collapsed = useCollapse()

  const [initStore, storeInitialized] = useDashboardStore((state) => [state.initStore, state.storeInitialized])

  const { data, error, loading } = useCompanyManagerDashboardListOfCompanies()

  useEffect(() => {
    const companies = data?.companyManagerDashboardListOfCompanies
    if (!!companies && companies.length) {
      initStore(companies)
    }
  }, [data, initStore])

  const canAccessDashboard =
    !!user.roles &&
    (user.roles.includes(RoleName.CompanyManager) || user.roles.includes(RoleName.Hr) || user.roles.includes(RoleName.BusinessPartner))

  const companies = data?.companyManagerDashboardListOfCompanies

  if (!canAccessDashboard || loading || error || !data || !companies || (!!companies.length && !storeInitialized)) {
    return (
      <ContentContainer collapsed={collapsed} fullHeight>
        <BackgroundBox r height="fullPage">
          <NewLoadingAndErrors
            isLoading={canAccessDashboard && (loading || !storeInitialized)}
            hasNoData={!data || !companies}
            isPermissionDenied={!canAccessDashboard}
            error={error}
            showSpinner
            t={t}
          />
        </BackgroundBox>
      </ContentContainer>
    )
  } else if (!!data && !companies.length) {
    return (
      <ContentContainer collapsed={collapsed} fullHeight>
        <BackgroundBox r height="fullPage">
          <PerFlexRow align="middle" justify="center" className="fullHeight">
            <PerEmpty
              icon="smileyConcerned_stroke"
              iconColor="default"
              iconSize="xxl"
              preserveLineBreaks
              info={t(getDashboardEmptyMessageKey(user.roles ?? []))}
            />
          </PerFlexRow>
        </BackgroundBox>
      </ContentContainer>
    )
  }
  return (
    <ContentContainer collapsed={collapsed} fullHeight>
      <DashboardViewLayout />
    </ContentContainer>
  )
}

export default DashboardView
